import Vue from 'vue'
import VeeValidate from 'vee-validate'

export default Vue.use(VeeValidate, {
  events: 'blur'
})
